/**
 * @description: 头条动态常用字段
 * @return {*}
 */
export const TOUTIAO_DYNAMIC_WORDS = ['日期', '时间', '账号简称']
export const TOUTIAO_PROJECT_DYNAMIC_WORDS = TOUTIAO_DYNAMIC_WORDS.concat(['项目组名', '计划组名'])
export const TOUTIAO_PLAN_DYNAMIC_WORDS = TOUTIAO_DYNAMIC_WORDS.concat(['定向包', '创意包'])
export const TOUTIAO_MENU_ID = 'M21070'
export const TOUTIAO_V3_MENU_ID = 'M21287'
export const DEFAULT_SCHEDULE_TIME = new Array(336).fill(0).join('')

const DEFAULT_SWITCH = {
  OFF: 'OFF',
  ON: 'ON'
}
/**
 * @description: 推广目的
 * @return {*}
 */
export const LANDING_TYPE = {
  APP: 'APP',
  MICRO_GAME: 'MICRO_GAME',
  MINI: 'MINI'
}
export const LANDING_TYPE_LIST = [
  {
    label: '应用推广',
    value: LANDING_TYPE.APP
  },
  {
    label: '小程序投放',
    value: LANDING_TYPE.MICRO_GAME
  },
  {
    label: '应用APP（微端）',
    value: LANDING_TYPE.MINI
  }
]

/**
 * @description: 子目标：DOWNLOAD 应用下载、LAUNCH 应用调起、RESERVE 预约下载；当 landing_type = APP 有效且必填
 * @return {*}
 */
export const APP_PROMOTION_TYPE = {
  DOWNLOAD: 'DOWNLOAD',
  LAUNCH: 'LAUNCH',
  RESERVE: 'RESERVE'
}
export const APP_PROMOTION_TYPE_LIST = [
  {
    label: '应用下载',
    value: APP_PROMOTION_TYPE.DOWNLOAD
  },
  {
    label: '应用调起',
    value: APP_PROMOTION_TYPE.LAUNCH
  },
  {
    label: '预约下载',
    value: APP_PROMOTION_TYPE.RESERVE
  }
]

/**
 * @description: 投放模式：MANUAL手动投放(默认值）、PROCEDURAL自动投放
 * @return {*}
 */
export const DELIVERY_MODE = { MANUAL: 'MANUAL', PROCEDURAL: 'PROCEDURAL' }
export const DELIVERY_MODE_LIST = [
  {
    label: '手动投放',
    value: DELIVERY_MODE.MANUAL
  },
  {
    label: '自动投放（UBMax）',
    value: DELIVERY_MODE.PROCEDURAL
  }
]
export const DELIVERY_TYPE = {
  NORMAL: 'NORMAL',
  DURATION: 'DURATION',
  UBX_INTELLIGENT: 'UBX_INTELLIGENT'
}
export const DELIVERY_TYPE_LIST = [
  {
    label: '常规投放',
    value: DELIVERY_TYPE.NORMAL
  },
  {
    label: '极速智投',
    value: DELIVERY_TYPE.DURATION
  },
  {
    label: '智能托管',
    value: DELIVERY_TYPE.UBX_INTELLIGENT
  }
]

/**
 * @description: 巨量引擎智擎版项目定向设置
 */
export const PROJECT_AUDIENCE_TYPE = {
  UNLIMITED: 'UNLIMITED',
  CUSTOM: 'CUSTOM'
}

/**
 * @description: 营销场景，允许值：VIDEO_AND_IMAGE 短视频/图片，LIVE直播
 * @description: 创建搜索周期稳投广告delivery_type = DURATION时，仅允许VIDEO_AND_IMAGE 短视频/图片
 * @return {*}
 */
export const MARKETING_GOAL = {
  VIDEO_AND_IMAGE: 'VIDEO_AND_IMAGE',
  LIVE: 'LIVE'
}
export const MARKETING_GOAL_LIST = [
  {
    label: '短视频/图片',
    value: MARKETING_GOAL.VIDEO_AND_IMAGE
  },
  {
    label: '直播',
    value: MARKETING_GOAL.LIVE
  }
]

export const MATERIAL_STYLE = {
  LIVE_MATERIALS: 'LIVE_MATERIALS',
  PROMOTION_MATERIALS: 'PROMOTION_MATERIALS'
}
export const MATERIAL_STYLE_LIST = [
  {
    label: '计划素材',
    value: MATERIAL_STYLE.PROMOTION_MATERIALS
  },
  {
    label: '直播素材',
    value: MATERIAL_STYLE.LIVE_MATERIALS
  }
]

/**
 * @description: 广告类型，允许值：ALL 通投广告 SEARCH 搜索广告
 * @return {*}
 */
export const AD_TYPE = {
  ALL: 'ALL',
  SEARCH: 'SEARCH'
}

export const APP_TYPE = {
  APP_ANDROID: 'APP_ANDROID',
  APP_IOS: 'APP_IOS',
  NONE: 'NONE'
}

/**
 * @description: 搜索快投：定向拓展，允许值：ON:开启（默认值）， OFF:关闭
 */
export const AUDIENCE_EXTEND = DEFAULT_SWITCH
export const AUDIENCE_EXTEND_LIST = [
  {
    label: '开启',
    value: AUDIENCE_EXTEND.ON
  },
  {
    label: '不开启',
    value: AUDIENCE_EXTEND.OFF
  }
]

/**
 * @description: 竞价策略
 * @property {CUSTOM} 稳定成本
 * @property {NO_BID} 最大转化
 * @property {UPPER_CONTROL} 最优成本
 * @property {EXPLORE_UPGRADE} 潜力探索
 */
export const BID_TYPE = {
  CUSTOM: 'CUSTOM',
  NO_BID: 'NO_BID',
  UPPER_CONTROL: 'UPPER_CONTROL',
  EXPLORE_UPGRADE: 'EXPLORE_UPGRADE'
}
export const BID_TYPE_LIST = [
  {
    label: '稳定成本',
    value: BID_TYPE.CUSTOM
  },
  {
    label: '最大转化',
    value: BID_TYPE.NO_BID
  },
  {
    label: '最优成本',
    value: BID_TYPE.UPPER_CONTROL
  }
]

/**
 * @description: 投放时间类型，允许值：SCHEDULE_FROM_NOW 从今天起长期投放; SCHEDULE_START_END 设置开始和结束日期
 * @return {*}
 */
export const SCHEDULE_TYPE = {
  FROM_NOW: 'SCHEDULE_FROM_NOW',
  START_END: 'SCHEDULE_START_END',
  SEVEN_DAYS: 'SCHEDULE_7_DAYS'
}

/**
 * @description: 投放时间端类型（内部标记参数）
 * @return {*}
 */
export const SCHEDULE_TIME_TYPE = {
  ALL: 'ALL',
  RANGE: 'RANGE'
}

/**
 * @description: 付费方式，允许值：PRICING_CPM 按展示付费; PRICING_CPC 按点击付费
 * @description: PRICING_OCPM 目标转化出价-按展示付费（默认值）; PRICING_OCPC 目标转化出价-按点击付费
 * @return {*}
 */
export const PRICING_TYPE = {
  PRICING_CPM: 'PRICING_CPM',
  PRICING_CPC: 'PRICING_CPC',
  PRICING_OCPM: 'PRICING_OCPM',
  PRICING_OCPC: 'PRICING_OCPC'
}

/**
 * @description: 投放速度
 * @return {*}
 */
export const BID_SPEED = {
  FAST: 'FAST',
  BALANCE: 'BALANCE'
}
export const BID_SPEED_LIST = [
  {
    label: '加速',
    value: BID_SPEED.FAST
  },
  {
    label: '匀速',
    value: BID_SPEED.BALANCE
  }
]

/**
 * @description: 项目预算类型， 允许值：BUDGET_MODE_INFINITE 不限; BUDGET_MODE_DAY 日预算; BUDGET_MODE_TOTAL 总预算
 */
export const BUDGET_MODE = {
  INFINITE: 'BUDGET_MODE_INFINITE',
  DAY: 'BUDGET_MODE_DAY',
  TOTAL: 'BUDGET_MODE_TOTAL'
}

/**
 * @description: 预算择优分配
 * @return {*}
 */
export const BUDGET_OPTIMIZE_SWITCH = DEFAULT_SWITCH

/**
 * @description: 优化目标
 * @property {AD_CONVERT_TYPE_ACTIVE}  激活
 * @property {AD_CONVERT_TYPE_PAY}  付费
 * @property {AD_CONVERT_TYPE_ACTIVE_REGISTER} 注册
 * @property {AD_CONVERT_TYPE_GAME_ADDICTION}  关键行为
 */
export const EXTERNAL_ACTION = {
  ACTIVE: 'AD_CONVERT_TYPE_ACTIVE',
  PAY: 'AD_CONVERT_TYPE_PAY',
  ACTIVE_REGISTER: 'AD_CONVERT_TYPE_ACTIVE_REGISTER',
  GAME_ADDICTION: 'AD_CONVERT_TYPE_GAME_ADDICTION'
}
export const EXTERNAL_ACTION_LIST = [
  {
    label: '激活',
    value: EXTERNAL_ACTION.ACTIVE
  },
  {
    label: '付费',
    value: EXTERNAL_ACTION.PAY
  },
  {
    label: '注册',
    value: EXTERNAL_ACTION.ACTIVE_REGISTER
  },
  {
    label: '关键行为',
    value: EXTERNAL_ACTION.GAME_ADDICTION
  }
]
/**
 * @description: 深度优化目标
 * @property {PURCHASE_ROI}  付费ROI
 * @property {PURCHASE_ROI_7D}  付费ROI-7日 // 1375418
 * @property {LT_ROI}  变现ROI
 * @property {LTV_ROI_SEVEN}  变现ROI-7日
 * @property {PURCHASE_ROI_THIRTY}  付费ROI-30日
 */
export const DEEP_EXTERNAL_ACTION = {
  DEFAULT: '',
  PURCHASE_ROI: 'AD_CONVERT_TYPE_PURCHASE_ROI',
  PURCHASE_ROI_7D: 'AD_CONVERT_TYPE_PURCHASE_ROI_7D',
  LT_ROI: 'AD_CONVERT_TYPE_LT_ROI',
  LTV_ROI_SEVEN: 'AD_CONVERT_TYPE_LTV_ROI_SEVEN',
  PURCHASE_ROI_THIRTY: 'AD_CONVERT_TYPE_PURCHASE_ROI_THIRTY'
}
export const DEEP_EXTERNAL_ACTION_LIST = [
  {
    label: '无',
    value: DEEP_EXTERNAL_ACTION.DEFAULT
  },
  {
    label: '付费ROI',
    value: DEEP_EXTERNAL_ACTION.PURCHASE_ROI
  },
  {
    label: '付费ROI-7日',
    value: DEEP_EXTERNAL_ACTION.PURCHASE_ROI_7D
  },
  {
    label: '变现ROI',
    value: DEEP_EXTERNAL_ACTION.LT_ROI
  },
  {
    label: '变现ROI-7日',
    value: DEEP_EXTERNAL_ACTION.LTV_ROI_SEVEN
  },
  {
    label: '付费ROI-30日',
    value: DEEP_EXTERNAL_ACTION.PURCHASE_ROI_THIRTY
  }
]

/**
 * @description: 深度优化方式 https://open.oceanengine.com/labels/7/docs/1696710760171535
 * @property {DEEP_BID_DEFAULT}  无
 * @property {BID_PER_ACTION}  每次付费
 * @property {ROI_COEFFICIENT} ROI系数
 * @property {DEEP_BID_MIN}  自定义双出价（手动出价方式下）
 * @property {FIRST_AND_SEVEN_PAY_ROI}  首日ROI+7日ROI
 * @property {PER_AND_SEVEN_PAY_ROI}  每次付费+7日ROI
 */
export const DEEP_BID_TYPE = {
  DEFAULT: 'DEEP_BID_DEFAULT',
  BID_PER_ACTION: 'BID_PER_ACTION',
  ROI_COEFFICIENT: 'ROI_COEFFICIENT',
  DEEP_BID_MIN: 'DEEP_BID_MIN',
  FIRST_AND_SEVEN_PAY_ROI: 'FIRST_AND_SEVEN_PAY_ROI',
  PER_AND_SEVEN_PAY_ROI: 'PER_AND_SEVEN_PAY_ROI'
}
export const DEEP_BID_TYPE_LIST = [
  {
    label: '无',
    value: DEEP_BID_TYPE.DEFAULT
  },
  {
    label: '每次付费',
    value: DEEP_BID_TYPE.BID_PER_ACTION
  },
  {
    label: 'ROI系数',
    value: DEEP_BID_TYPE.ROI_COEFFICIENT
  },
  {
    label: '自定义双出价',
    value: DEEP_BID_TYPE.DEEP_BID_MIN
  },
  {
    label: '首日ROI+7日ROI',
    value: DEEP_BID_TYPE.FIRST_AND_SEVEN_PAY_ROI
  },
  {
    label: '每次付费+7日ROI',
    value: DEEP_BID_TYPE.PER_AND_SEVEN_PAY_ROI
  }
]

/**
 * @description: 原生广告
 * @property {ACCOUNT}  账号信息
 * @property {AWEME}  抖音号
 * @property {AWEME_VIDEO} 达人视频
 */
export const AMEME_TYPE = {
  ACCOUNT: 'ACCOUNT',
  DOUYIN: 'AWEME',
  AWEME_VIDEO: 'AWEME_VIDEO'
}
export const AMEME_TYPE_LIST = [
  {
    label: '账号信息',
    value: AMEME_TYPE.ACCOUNT
  },
  {
    label: '抖音号',
    value: AMEME_TYPE.DOUYIN
  },
  {
    label: '达人视频',
    value: AMEME_TYPE.AWEME_VIDEO
  }
]

/**
 * @description: 原生锚点
 * @property {ACCOUNT}  账号信息
 * @property {AWEME}  抖音号
 * @property {AWEME_VIDEO} 达人视频
 */
export const ANCHOR_RELATED_TYPE = {
  OFF: 'OFF',
  AUTO: 'AUTO',
  SELECT: 'SELECT'
}
/**
 * @description: 出价值类型，
 * @property {FIXED}  固定出价
 * @property {RANGE}  区间出价
 */
export const BID_VALUE_TYPE = {
  FIXED: 1,
  RANGE: 2
}

export const IMAGE_MODE = {
  LARGE_VERTICAL: 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL',
  LARGE: 'CREATIVE_IMAGE_MODE_LARGE',
  SMALL: 'CREATIVE_IMAGE_MODE_SMALL',
  VIDEO_VERTICAL: 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL',
  VIDEO: 'CREATIVE_IMAGE_MODE_VIDEO'
}

export const IS_FEED_AND_FAV_SEE = DEFAULT_SWITCH

export const VIDEO_HP_VISIBILITY = {
  OFF: 'ALWAYS_VISIBLE',
  ON: 'HIDE_VIDEO_ON_HP'
}

/**
 * @description: 蓝海流量设置允许值
 * @property {OFF}  不启用
 * @property {ON} 启用
 */
export const BLUE_FLOW_PACKAGE_SETTING_SWITCH = DEFAULT_SWITCH

/**
 * @description: 智能生成行动号召按钮
 * @return {*}
 */
export const INTELLIGENT_GENERATION_SWITCH = DEFAULT_SWITCH

/**
 * @description: 智能拓流
 * @return {*}
 */
export const AUTO_EXTEND_TRAFFIC_SWITCH = DEFAULT_SWITCH

/**
 * @description: 动态创意高级设置
 * @return {*}
 */
export const DYNAMIC_CREATIVE_SWITCH = DEFAULT_SWITCH
export const ADVANCED_DC_SETTING_ENUM = {
  OPTIMIZE_SEARCH_RESULTS_PAGE: 'OPTIMIZE_SEARCH_RESULTS_PAGE', // 优化视频、图片、标题等搜索结果页内容
  OPTIMIZE_LANDING_PAGE: 'OPTIMIZE_LANDING_PAGE' // 优化落地页
}

export const CREATE_TYPE_ENUM = {
  NEW: 'NEW',
  INHERIT: 'INHERIT'
}
